// Modules
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
// Components
import PortfolioGallery from './PortfolioGallery/PortfolioGallery';
// Containers
import OMLightbox from '../../containers/OMContainers/OMLightbox/OMLightbox';
// Helpers
import buildVideoLinks from '../../utils/buildVideoLinks';
// Styles
import * as styles from './Portfolio.scss';


const Portfolio = (props) => {
  const renderLightbox = () => {
    const images = get(props, 'images') || [];
    const videos = (get(props, 'videos') || []).map(video => ({ ...video, ...buildVideoLinks(video) }));

    return (
      <OMLightbox
        currentImage={props.currentImage || 0}
        changeLightboxActiveSlide={props.changeLightboxActiveSlide}
        translate={props.translate}
        images={images}
        videos={videos}
        isOpen={!props.isDetailsModalOpen && props.isOpen}
        hideLightbox={props.hideLightbox}
        locale={props.locale}
        isRtl={props.isRtl}
        isMobile={props.isMobile}
      />
    );
  };

  return (
    <div className={styles.portfolioWrapper}>
      <div className={styles.title}>
        {props.portfolioTitle}
      </div>
      <PortfolioGallery
        images={props.images}
        videos={props.videos}
        openLightbox={props.openLightbox}
      />
      {renderLightbox()}
    </div>
  );
};

Portfolio.propTypes = {
  images: PropTypes.array,
  videos: PropTypes.array,
  openLightbox: PropTypes.func,
  hideLightbox: PropTypes.func,
  changeLightboxActiveSlide: PropTypes.func,
  translate: PropTypes.func,
  portfolioTitle: PropTypes.func,
  currentImage: PropTypes.number,
  locale: PropTypes.string,
  isOpen: PropTypes.bool,
  isDetailsModalOpen: PropTypes.bool,
  isRtl: PropTypes.bool,
  isMobile: PropTypes.bool
};

export default Portfolio;
